import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useWebsocket } from '../../hooks/useWebsocket'
import PilotList from '../../modules/pilots/PilotList'
import { addSubscription, removeSubscription } from '../../state/websocket.slice'
import { getWebsocketChannel } from '../../utils/websocket'

function PilotsPage() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { subscribeToChannel, unsubscribeFromChannel } = useWebsocket()

  const handleViewPilot = (pilot) => {
    navigate(`/pilots/${pilot._id}`)
  }

  const handleEditPilot = (pilot) => {
    console.log('Editing pilot:', pilot)
    // TODO: Implement edit pilot functionality
  }

  const handleDeletePilot = (pilot) => {
    console.log('Deleting pilot:', pilot)
    // TODO: Implement delete pilot functionality
  }

  useEffect(() => {
    const channelName = getWebsocketChannel().pilotList

    if (channelName) {
      subscribeToChannel(channelName)
      dispatch(addSubscription(channelName))
    }

    return () => {
      if (channelName) {
        unsubscribeFromChannel(channelName)
        dispatch(removeSubscription(channelName))
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="max-w-7xl mx-auto">
      <div className="mb-6 text-left">
        <h1 className="text-2xl font-bold text-neutral-900 dark:text-white mb-2">
          Pilot Management
        </h1>
        <p className="text-neutral-600 dark:text-neutral-400">
          Manage pilot schedules, certifications, and assignments
        </p>
      </div>

      <PilotList
        onViewPilot={handleViewPilot}
        onEditPilot={handleEditPilot}
        onDeletePilot={handleDeletePilot}
      />
    </div>
  )
}

export default PilotsPage
